import join from 'join-classnames';
import styles from './footer.css';

const footerTemplate = () => `
<div class="${styles.footer}" id='footer-container'>
<p class="${join(styles.copyright)}" id='copyright'> Copyright 2017 O.C. Tanner Company</p>

</div>
`;

export default footerTemplate;
